export const findGeocode = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    latLng: woosmap.map.LatLngLiteral,
    locale: string,
) => {
    const geocodeResponse = await LocalitiesService.geocode({
        latLng: latLng,
        language: locale,
    });

    const geocodeResult = geocodeResponse?.results.at(0);

    return geocodeResult;
};
